import { useState } from 'react'
import { CustomDropdown } from './CustomDropdown'

interface IOption {
  [key: string]: string
}

interface IDropdown {
  filter: string | undefined
  setFilters: (o: any) => void
  options: IOption[]
  isLoading?: boolean
  placeholder: string
  onClose: (cb: () => void) => void
  onConfirm: (cb: () => void) => void
}

export const SortDropdown = ({
  filter,
  setFilters = () => null,
  options = [],
  isLoading = false,
  placeholder,
  onClose,
  onConfirm
}: IDropdown) => {
  const [isOpen, setIsOpen] = useState(false)

  const onClearFilters = () => {
    setIsOpen(false)
  }

  const handleOnClose = () => {
    setIsOpen(false)
  }

  const handleSelect = (id: string) => {
    if (id === filter) {
      setFilters(undefined)
    } else {
      setFilters(id)
      setIsOpen(false)
    }
  }
  const renderOptions = () => {
    return options?.map(({ option, id }: IOption) => {
      return (
        <div
          key={id}
          onClick={() => handleSelect(id)}
          className="w-full flex rounded-sm px-4 py-2 cursor-pointer hover:!bg-surface-gray-20 hover:transition-all"
        >
          <span className={`text-sm ${filter === id ? 'font-semibold' : ''}`}>
            {option}
          </span>
        </div>
      )
    })
  }

  return (
    <CustomDropdown
      isOpen={isOpen && !isLoading}
      setIsOpen={isLoading ? () => null : setIsOpen}
      placeholder={placeholder}
      menuTitle={placeholder}
      renderOptions={renderOptions()}
      onReset={onClearFilters}
      withSearch={false}
      searchVal=""
      setSearchVal={() => null}
      activeFilters={0}
      onConfirm={() => onConfirm(handleOnClose)}
      onClose={() => onClose(handleOnClose)}
      withoutFooter={true}
      dropdownClassName="max-h-fit !p-0 !min-w-[200px] overflow-hidden"
      pillButtonClassName={`w-full justify-between border-0 ${
        isOpen ? '!bg-dark' : '!bg-[transparent]'
      }`}
      pillButtonContainerClassName="w-full"
      placeholderIcon="sort"
      optionsContainerClassNames="!gap-0"
      withoutHeader={true}
    />
  )
}
